export const testTiktokUrl = (url: string) => {
  return /^https:\/\/(?:m|www|vm)?\.?tiktok\.com\/((?:.*\b(?:(?:usr|v|embed|user|video)\/|\?shareId=|\&item_id=)(\d+))|\w+)/.test(
    url,
  )
}

export const testYoutubeUrl = (url: string) => {
  return /^(?:https?:\/\/|\/\/)?(?:www\.|m\.|.+\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|shorts\/|feeds\/api\/videos\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?![\w-])/.test(
    url,
  )
}

/**
 * @reference https://github.com/yt-dlp/yt-dlp/blob/master/yt_dlp/extractor/facebook.py
 */
const facebookUrlRegex = new RegExp(
  '(?:' +
    'https?://' +
    '(?:[\\w-]+\\.)?(?:facebook\\.com|facebookwkhpilnemxj7asaniu7vnjjbiltxjqhye3mhbshg7kx5tfyd\\.onion)/' +
    '(?:[^#]*?\\#!/)?' +
    '(?:' +
    '(?:' +
    'permalink\\.php|' +
    'video/video\\.php|' +
    'photo\\.php|' +
    'video\\.php|' +
    'video/embed|' +
    'story\\.php|' +
    'watch(?:/live)?/?' +
    ')\\?(?:.*?)(?:v|video_id|story_fbid)=|' +
    '[^/]+/videos/(?:[^/]+/)?|' +
    '[^/]+/posts/|' +
    'events/(?:[^/]+/)?|' +
    'groups/[^/]+/(?:permalink|posts)/|' +
    'watchparty/' +
    ')|' +
    'facebook:' +
    ')' +
    '(?<id>pfbid[A-Za-z0-9]+|\\d+)',
  'i',
)
const facebookReelUrlRegex =
  /https?:\/\/(?:[\w-]+\.)?facebook\.com\/reel\/(?:\d+)/
const facebookShareUrlRegex = /https?:\/\/www\.facebook\.com\/share\/r\/[^/]+/
// https://fb.watch/tEpm2EwxMe/
const facebookWatchUrlRegex = /https?:\/\/fb\.watch\/[^/]+/
export const testFacebookUrl = (url: string) => {
  return (
    facebookUrlRegex.test(url) ||
    facebookReelUrlRegex.test(url) ||
    facebookShareUrlRegex.test(url) ||
    facebookWatchUrlRegex.test(url)
  )
}

export const textFacebookWatchUrl = (url: string) => {
  return facebookWatchUrlRegex.test(url)
}

/**
 * @reference https://github.com/yt-dlp/yt-dlp/blob/master/yt_dlp/extractor/vk.py
 */
const vkUrlRegex = new RegExp(
  'https?:\\/\\/' +
    '(?:' +
    '(?:' +
    '(?:(?:m|new)\\.)?vk\\.com\\/video_|' +
    '(?:www\\.)?daxab\\.com\\/' +
    ')' +
    'ext\\.php\\?(?<embed_query>.*?\\boid=(?<oid>-?\\d+).*?\\bid=(?<id>\\d+).*)|' +
    '(?:' +
    '(?:(?:m|new)\\.)?vk\\.com\\/(?:.+?\\?.*?z=)?(?:video|clip)|' +
    '(?:www\\.)?daxab\\.com\\/embed\\/' +
    ')' +
    '(?<videoid>-?\\d+_\\d+)(?:.*\\blist=(?<list_id>([\\da-f]+)|(ln-[\\da-zA-Z]+)))?' +
    ')',
  'i',
)
export const testVkUrl = (url: string) => {
  return vkUrlRegex.test(url)
}
